import { Component } from '@angular/core';
import { TranslatorService } from '../../../../services/translator_service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RTLDivDirectiveDirective } from '../../../../directives/rtldiv-directive.directive';
import { MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-cancel-installation-dialog',
  imports: [TranslatePipe,FormsModule, RTLDivDirectiveDirective,MatDialogModule,ReactiveFormsModule,
    CommonModule],  
  templateUrl: './cancel-installation-dialog.html',
  styleUrl: './cancel-installation-dialog.scss',
})
export class CancelInstallationDialog {
  currentLang: string;
  translateSub;
  translationsObj;

  constructor(private translator: TranslatorService) { 
    this.currentLang = this.translator.getTranslationLanguage();      
    this.translateSub = this.translator.getTranslation(this.currentLang).subscribe(translations => {
      this.translationsObj = translations;
    });
  }

  ngOnInit() {
  }
}
